<div class="template-editor">

    @if (showWorkflowBanner()) {
    <div class="workflow-banner">
        <button mat-icon-button class="workflow-dismiss" matTooltip="Dismiss" (click)="showWorkflowBanner.set(false)">
            <mat-icon>close</mat-icon>
        </button>
        <div class="workflow-copy">
            <span class="workflow-eyebrow">Template Workflow</span>
            <h2>Save the layout first, then upload images for saved image slots.</h2>
            <p>The backend replaces the full slot list on each state save, so finish the state layout before adding or
                replacing slot images.</p>
        </div>
        <div class="workflow-steps">
            <span class="workflow-step">1. Create template</span>
            <span class="workflow-step">2. Save state layout</span>
            <span class="workflow-step">3. Upload slot images</span>
        </div>
    </div>
    }

    <!-- Editor header -->
    <div class="editor-header">
        <button mat-icon-button matTooltip="Back to display list" (click)="close.emit()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <div class="editor-title">
            <mat-icon>dashboard_customize</mat-icon>
            <span>Template Editor</span>
            <span class="display-subtitle">{{ display.deviceName }}</span>
        </div>
        @if (template()) {
        <button mat-stroked-button matTooltip="Clone or apply template to other displays"
            (click)="showCloneModal.set(!showCloneModal())">
            <mat-icon>content_copy</mat-icon> Clone
        </button>
        }
    </div>

    @if (showCloneModal() && template()) {
    <app-clone-template-modal [templateId]="template()!.id!" [sourceDisplayId]="display.displayId!" [siteId]="siteId"
        (closed)="showCloneModal.set(false)" (cloned)="showCloneModal.set(false); loadTemplate()" />
    }

    <mat-divider />

    <!-- Loading -->
    @if (loading()) {
    <div class="loading-center">
        <mat-spinner diameter="48" />
    </div>
    }

    <!-- No template — create form -->
    @else if (!template()) {
    <app-create-template-item [display]="display" [saving]="saving()" (create)="createTemplate($event)" />
    }

    <!-- Template exists — editor -->
    @else {
    <app-edit-template-item [display]="display" [template]="template()!" [saving]="saving()"
        [selectedState]="selectedState()" (stateSelected)="selectState($event)" (saveName)="saveTemplateName($event)"
        (saveLayout)="saveStateLayout($event)" (removeLayout)="removeStateLayout($event)"
        (cloneState)="cloneState($event)" [errorMessage]="errorMessage()" />

    }